// extracted by mini-css-extract-plugin
export var borderRadius = "_es-4";
export var large = "_es-3";
export var logoContainer = "_es-0";
export var nameLogo = "_es-2";
export var small = "_es-1";